import React, { Component } from 'react'
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { compose } from 'redux';

import { Divider } from 'primereact/divider';
import { Timeline } from 'primereact/timeline';

import BannerForm from '@components/Section/Forms/Banner';
import BannerImgRigthForm from '@components/Section/Forms/BannerImgRigthForm';
import FloatingCardsForm from '@components/Section/Forms/FloatingCardsForm';
import BannerImgLeftForm from '@components/Section/Forms/BannerImgLeftForm';
import DescriptionImgRigthForm from '@components/Section/Forms/DescriptionImgRigthForm';
import DocumentsCards from '@components/Section/Forms/DocumentsCards';
import ProcessCards from '@components/Section/Forms/ProcessCards';
import BannerMain from '@components/Section/Forms/BannerMain';
import Blocks3 from '@components/Section/Forms/Blocks3';
import BannerCodeEthics from '@components/Section/Forms/BannerCodeEthics';
import SlidersLogos from '@components/Section/Forms/SlidersLogos';
import Bullets from '@components/Section/Forms/Bullets';
import CapacitateEmpleo from '@components/Section/Forms/CapacitateEmpleo';
import TabsDescription from '@components/Section/Forms/TabsDescription';
import NotFoundComponentSelected from '@components/Section/Forms/NotFoundComponentSelected';
import UltimosDocumentosAñadidos from '@components/Section/Forms/UltimosDocumentosAñadidos';
import CarouselForm from '@components/Section/Forms/Carousel';
import FrequentQuestionsForm from '@components/Section/Forms/FrequentQuestions';
import DescriptionForm from '@components/Section/Forms/Description';
import RelatedLinksForm from '@components/Section/Forms/RelatedLinks';
import InformationBlocksTableForm from '@components/Section/Forms/InformationBlocksTable';
import InformationBlocksCarouselForm from '@components/Section/Forms/InformationBlocksCarousel';
import OutServiceForm from '@components/Section/Forms/OutService';

const CURRENT_STEP = 2

class ComponentLayout extends Component {
  constructor(props) {
    super(props)
    this.state = {
      step: 0,
      totalSteps: 0,
      maxStep: 0,
      itemsStep: [],
      validateSelected: [],
      loadingPage: true,
      parentMaxStep: this.props.parentMaxStep
    }
  }

  componentDidMount () {
    const { componentsSelected, t } = this.props
    const validateSelected = componentsSelected.filter((item => !item.disabledEdit))
    const itemsStep = validateSelected.map(item => ({title: t(item.titleSection)}))
    this.setState({
      itemsStep,
      totalSteps: validateSelected.length,
      validateSelected,
      loadingPage: false
    })
  }

  nexStep = () => {
    const { step, totalSteps, maxStep } = this.state
    const { success } = this.props
    this.setState({ btnSubmitLoading: true });
    if ((step + 1) === totalSteps) return success()
    const validateMaxStep = step + 1 > maxStep ? step + 1 : maxStep
    this.setState(prevState => ({step: prevState.step + 1, maxStep: validateMaxStep}))
    return this.setState({ btnSubmitLoading: false });
  }

  backStep = () => {
    const { step, totalSteps } = this.state
    const { onBack, success } = this.props
    this.setState({ btnSubmitLoading: true });
    if (step === 0) return onBack()
    if (step === totalSteps) return success()
    this.setState(prevState => ({step: prevState.step - 1}))
    this.setState({ btnSubmitLoading: false });
  }

  validateOnchangeStep = (index) => {
    const { maxStep, parentMaxStep } = this.state
    if (parentMaxStep >= CURRENT_STEP) return this.setState({step: index})
    if (index > maxStep) return true
    return this.setState({step: index})
  }

  render() {
    const { itemsStep, step, btnSubmitLoading, loadingPage, validateSelected } = this.state
    const { componentsSelected, success } = this.props
    const stepsSubRender = () => {
      if (!validateSelected || !validateSelected.length) return (
        <NotFoundComponentSelected
          success={success}
          onBack={this.backStep}
        />
      )
      const getParentClass = validateSelected[step].parentClass.class
      // if (getParentClass === 'sct-banner') {
      //   return (
      //     <BannerForm
      //       success={this.nexStep}
      //       onBack={this.backStep}
      //       btnSubmitLoading={btnSubmitLoading}
      //     />
      //   );
      // }
      if (getParentClass === 'sct-banner-img-rigth') {
        return (
          <BannerImgRigthForm
            success={this.nexStep}
            onBack={this.backStep}
            btnSubmitLoading={btnSubmitLoading}
          />
        );
      }
      if (getParentClass === 'sct-floating-cards') {
        return (
          <FloatingCardsForm
            success={this.nexStep}
            onBack={this.backStep}
            btnSubmitLoading={btnSubmitLoading}
          />
        );
      }
      if (getParentClass === 'sct-banner-img-left') {
        return (
          <BannerImgLeftForm
            success={this.nexStep}
            onBack={this.backStep}
            btnSubmitLoading={btnSubmitLoading}
          />
        );
      }
      if (getParentClass === 'sct-description-img-rigth') {
        return (
          <DescriptionImgRigthForm
            success={this.nexStep}
            onBack={this.backStep}
            btnSubmitLoading={btnSubmitLoading}
          />
        );
      }
      if (getParentClass === 'sct-cards-doc') {
        return (
          <DocumentsCards
            success={this.nexStep}
            onBack={this.backStep}
            btnSubmitLoading={btnSubmitLoading}
          />
        );
      }
      if (getParentClass === 'sct-processes') {
        return (
          <ProcessCards
            success={this.nexStep}
            onBack={this.backStep}
            btnSubmitLoading={btnSubmitLoading}
          />
        );
      }
      if (getParentClass === 'sct-main-banner') {
        return (
          <BannerMain
            success={this.nexStep}
            onBack={this.backStep}
            btnSubmitLoading={btnSubmitLoading}
          />
        );
      }
      if (getParentClass === 'sct-3blocks') {
        return (
          <Blocks3
            success={this.nexStep}
            onBack={this.backStep}
            btnSubmitLoading={btnSubmitLoading}
          />
        );
      }
      if (getParentClass === 'sct-banner-code-ethics') {
        return (
          <BannerCodeEthics
            success={this.nexStep}
            onBack={this.backStep}
            btnSubmitLoading={btnSubmitLoading}
          />
        );
      }
      if (getParentClass === 'sliders-logos') {
        return (
          <SlidersLogos
            success={this.nexStep}
            onBack={this.backStep}
            btnSubmitLoading={btnSubmitLoading}
          />
        );
      }
      if (getParentClass === 'sct-bullets') {
        return (
          <Bullets
            success={this.nexStep}
            onBack={this.backStep}
            btnSubmitLoading={btnSubmitLoading}
          />
        );
      }
      if (getParentClass === 'sct-capacitate-empleo') {
        return (
          <CapacitateEmpleo
            success={this.nexStep}
            onBack={this.backStep}
            btnSubmitLoading={btnSubmitLoading}
          />
        );
      }
      if (getParentClass === 'sct-tabs-descripcion') {
        return (
          <TabsDescription
            success={this.nexStep}
            onBack={this.backStep}
            btnSubmitLoading={btnSubmitLoading}
          />
        );
      }
      if (getParentClass === 'sct-ultimos-documentos') {
        return (
          <UltimosDocumentosAñadidos
            success={this.nexStep}
            onBack={this.backStep}
            btnSubmitLoading={btnSubmitLoading}
          />
        );
      }
      // if (getParentClass === 'sct-carrousel') {
      //   return (
      //     <CarouselForm
      //       success={this.nexStep}
      //       onBack={this.backStep}
      //       btnSubmitLoading={btnSubmitLoading}
      //     />
      //   );
      // }
      // if (getParentClass === 'sct-faq') {
      //   return (
      //     <FrequentQuestionsForm
      //       success={this.nexStep}
      //       onBack={this.backStep}
      //       btnSubmitLoading={btnSubmitLoading}
      //     />
      //   );
      // }
      // if (getParentClass === 'sct-description') {
      //   return (
      //     <DescriptionForm
      //       success={this.nexStep}
      //       onBack={this.backStep}
      //       btnSubmitLoading={btnSubmitLoading}
      //     />
      //   );
      // }
      // if (getParentClass === 'sct-links') {
      //   return (
      //     <RelatedLinksForm
      //       success={this.nexStep}
      //       onBack={this.backStep}
      //       btnSubmitLoading={btnSubmitLoading}
      //     />
      //   );
      // }
      // if (getParentClass === 'sct-blocks') {
      //   return (
      //     <InformationBlocksTableForm
      //       success={this.nexStep}
      //       onBack={this.backStep}
      //       btnSubmitLoading={btnSubmitLoading}
      //     />
      //   );
      // }
      // if (getParentClass === 'sct-blocks-carrousel') {
      //   return (
      //     <InformationBlocksCarouselForm
      //       success={this.nexStep}
      //       onBack={this.backStep}
      //       btnSubmitLoading={btnSubmitLoading}
      //     />
      //   );
      // }
      // if (getParentClass === 'our-services-section') {
      //   return (
      //     <OutServiceForm
      //       success={this.nexStep}
      //       onBack={this.backStep}
      //       btnSubmitLoading={btnSubmitLoading}
      //     />
      //   );
      // }
      return true;
    };

    const customizedMarker = ( index) => {
      if (index === step) return (<i className="pi pi-circle-on cursor-pointer" onClick={() => this.validateOnchangeStep(index)} style={{ color: "#ffe357", fontSize: "1.4rem" }}/>)
      if (index < step) return (<i className="pi pi-check cursor-pointer" onClick={() => this.validateOnchangeStep(index)} style={{ color: "#0db02b", fontSize: "1.4rem" }}/>)
      return (<i className="pi pi-circle-off cursor-pointer" onClick={() => this.validateOnchangeStep(index)} style={{ color: "#bdc2ce", fontSize: "1.4rem" }}/>)
    };

    const contentTimeline = (item, index) => {
      return (<p className="cursor-pointer" onClick={() => this.validateOnchangeStep(index)}>{item.title}</p>)
    }

    if (loadingPage) return true
    return (
      <div className="p-grid p-mt-4">
        { componentsSelected.length ? (
          <div className="p-col-12 p-md-3 p-lg-3">
            <Timeline value={itemsStep} align="right" marker={(item, index) => customizedMarker(index)} content={(item, index) => contentTimeline(item, index)} />
          </div>
        ) : ''
        }
        <Divider layout="vertical" />
        <div className="p-col">
          {stepsSubRender()}
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  componentsSelected: state.section.componentsSelected,
});

export default compose(
  withTranslation(),
  connect(mapStateToProps, null)
)(ComponentLayout);
